import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FwcModal } from '../../../../fwc-lib.js';

@Component({
    selector: 'app-suggested-address-modal',
    templateUrl: './suggested-address-modal.component.html',
    styleUrls: ['./suggested-address-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SuggestedAddressModalComponent implements OnInit {
  @Input() aboutYouFormData: any
  @Input() suggestedAddress: any
  @Output() updatedAboutYouData: EventEmitter<any> = new EventEmitter<any>();
  selectedAddress: any
  constructor() {
    const fwcModal = new FwcModal();
    fwcModal.build();
  }

  ngOnInit(): void {
  }

  openModal() {
    const modal = document.getElementById('addressModal');
    modal.setAttribute('open', '');
  }

  closeModal() {
    const modal = document.getElementById('addressModal');
    modal.removeAttribute('open');
  }

  refreshFocusTrap() {
    const modal = document.getElementById('addressModal') as any;
    if (modal && modal.resetModalFocusTrap) {
      setTimeout(() => {
        modal.resetModalFocusTrap();
      }, 0);
    }
  }

  onBack() {
    this.closeModal();
  }

  onConfirmClick() {
    if (this.selectedAddress == 'current') {
      const formData = this.aboutYouFormData;
      this.aboutYouFormData.address = formData.address;
      this.aboutYouFormData.address2 = formData.address2;
      this.aboutYouFormData.city = formData.city;
      this.aboutYouFormData.state = formData.state;
      this.aboutYouFormData.zip = formData.zip;
    } else {
      this.aboutYouFormData.address = this.suggestedAddress.address;
      this.aboutYouFormData.address2 = this.suggestedAddress.address2;
      this.aboutYouFormData.city = this.suggestedAddress.city;
      this.aboutYouFormData.state = this.suggestedAddress.state;
      this.aboutYouFormData.zip = this.suggestedAddress.zipcode;
    }
    this.updatedAboutYouData.emit(this.aboutYouFormData);
    this.selectedAddress = 'current'
    this.closeModal();
  }

}
